module.exports = __webpack_public_path__ + "static/media/BM 05.62bc650d.png";